<wa-card class="card-header">
  <div slot="header" class="wa-split">
   <h3 class="wa-heading-s"> Upload survey JSON file </h3>
  </div>
    <div class="wa-stack">
      @if (!fileToUpload) {
        <wa-callout variant="neutral">
          <wa-icon slot="icon" name="circle-info"></wa-icon>
          Please choose a JSON file for upload to create the survey.
        </wa-callout>
      } @else if (!!fileToUpload && fileToUpload.type !== 'application/json') {
        <wa-callout variant="danger">
          <wa-icon slot="icon" name="triangle-exclamation"></wa-icon>
          File must be of type JSON; please choose a different file.
        </wa-callout>
      } @else if (!!fileToUpload && fileToUpload.type === 'application/json') {
        <wa-callout variant="success">
          <wa-icon slot="icon" name="circle-check"></wa-icon>
          File '{{ fileToUpload.name }}' selected; press 'submit' to start the import.
        </wa-callout>
      }
    <wa-button
      variant="brand"
      (click)="fileUpload.click()">
      <wa-icon name="upload" variant="solid" label="upload"></wa-icon>
      choose JSON file to upload
    </wa-button>
    <input #fileUpload
           type="file"
           class="file-input"
           (change)="onFileSelected($event)">
  </div>
</wa-card>
